import React from "react";

function SheetmusicPage() {
  return <div className="middle">Sheetmusic Page</div>;
}

export default SheetmusicPage;
